import { NgClass, NgTemplateOutlet } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'infos-guidance',
  imports: [MatIconModule, NgTemplateOutlet, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex items-center justify-center my-10" [ngClass]="{ 'mx-20': !noSideMargin }">
      <mat-icon class="mr-10" [class.text-red!]="warningGuidance">
        {{ warningGuidance ? 'warning' : 'info_outlined' }}
      </mat-icon>

      @if (guidanceTemplate) {
        <ng-container [ngTemplateOutlet]="guidanceTemplate" />
      } @else {
        <span class="body-1">{{ guidanceText }}</span>
      }
    </div>
  `
})
export class InfosGuidanceComponent {
  @Input() guidanceTemplate: TemplateRef<any>;
  @Input() guidanceText = '';
  @Input({ transform: booleanAttribute }) warningGuidance = false;
  @Input({ transform: booleanAttribute }) noSideMargin = false;
}
